'use strict';

export function slideUp(el, duration= 500) {
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.boxSizing = 'border-box';
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  window.setTimeout( () => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

export function slideDown(el, duration= 500) {
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;

  if(display === 'none') {
    display = 'block';
  }

  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.boxSizing = 'border-box';
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

export function slideToggle(el, duration = 500) {
  if (window.getComputedStyle(el).display === 'none') {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
}

export function htmlSearch(data, container) {
  container.innerHTML = '';
  data.forEach((item) => {
    let li = document.createElement('li');
    li.className = 'search-box__item';
    li.innerHTML = `<a href="${item.url}" class="search-box__link">${item.title}</a>`;

    container.append(li);
  });
}

export function ajaxSearch(string, resultList) {
  let formData = new FormData();
  formData.append('action', 'search');
  formData.append('search', string);

  fetch(themeVar.url, {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    if(data.status == 'fail') {
      resultList.classList.remove('search-box__list--open');
      return false;
    }

    htmlSearch(data.search, resultList);
    resultList.classList.add('search-box__list--open');
  });
}